import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgMultiGatewayPaymentsComponent } from './ng-multi-gateway-payments.component';
import { NgMultiGatewayPaymentsService } from './ng-multi-gateway-payments.service';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';

@NgModule({
  declarations: [
    NgMultiGatewayPaymentsComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgxMaskDirective, NgxMaskPipe
  ],
  exports: [
    NgMultiGatewayPaymentsComponent
  ],
  providers: [
    NgMultiGatewayPaymentsService,
    provideNgxMask(),
  ]
})
export class NgMultiGatewayPaymentsModule { }
